export default "__VITE_ASSET__FkTLTZLt__"